import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Params } from '@angular/router';
import { CAMPAIGN_CONTENT_MAPPINGS } from './campaign-content.mappings';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CampaignContentService {
  paramName = 'zeus_utm_campaign';

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  public captureCampaignCode(): void {
    // Use URLSearchParams instead of ActivatedRoute to avoid memory leaks and random empty object issues
    const queryParams = new URLSearchParams(window?.location?.search);
    const queryParamsObject: Params = {};

    queryParams.forEach((value, key) => {
      queryParamsObject[key] = value;
    });
    if (isPlatformBrowser(this.platformId)) {
      if (Object.keys(queryParamsObject).length) {
        this.setQueryParams(queryParamsObject);
      }
    }
  }

  private setQueryParams(params: Params): void {
    // eslint-disable-next-line prefer-const
    let campaignParams = { ...params };
    if (campaignParams?.utm_campaign || campaignParams?.zeus_utm_campaign) {
      campaignParams.utm_campaign = campaignParams?.utm_campaign || campaignParams?.zeus_utm_campaign;
    }

    if (campaignParams?.utm_campaign) {
      sessionStorage.removeItem(this.paramName);
      sessionStorage.setItem(this.paramName, JSON.stringify(campaignParams));
    } else {
      sessionStorage.removeItem(this.paramName);
    }
  }

  public appendCampaignCodeToQueryString(url: string): string {
    let utmCodes = '';
    if (isPlatformBrowser(this.platformId)) {
      utmCodes = JSON.parse(sessionStorage.getItem(this.paramName));
    }
    if (utmCodes && url) {
      const utmParmas = Object.keys(utmCodes)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(utmCodes[k])}`)
        .join('&');
      url += (url.split('?')[1] ? '&' : '?') + `${utmParmas}`;
    }
    return url;
  }

  public getStrapiUID(currentStrapiUid: string): string {
    let newStrapiUid = currentStrapiUid;
    let campaignCode = '';
    if (isPlatformBrowser(this.platformId)) {
      campaignCode = sessionStorage.getItem(this.paramName);
    }
    if (campaignCode) {
      const results = CAMPAIGN_CONTENT_MAPPINGS.filter(
        (map) => map.CampaignCode === campaignCode && map.TargetStrapiUid === currentStrapiUid
      );
      if (results && results.length > 0) {
        newStrapiUid = results[0].NewStrapiUid;
      }
    }
    return newStrapiUid;
  }
}
